const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:8787'

export interface LeadSubmission {
  // Contact
  name: string
  email: string
  phone?: string
  
  // Service
  service_type: string
  aquarium_size?: string
  aquarium_type?: string
  water_type?: string
  
  // Location & Timeline
  zip_code?: string
  urgency?: string
  budget?: string
  notes?: string
  
  // Photos (R2 keys)
  photos?: string[]
  
  // Tracking
  gclid?: string
  fbclid?: string
  utm_source?: string
  utm_medium?: string
  utm_campaign?: string
  utm_content?: string
  utm_term?: string
  referrer?: string
  landing_page?: string
}

export interface ApiResponse<T = unknown> {
  success: boolean
  error?: string
  data?: T
}

export async function submitLead(
  data: LeadSubmission
): Promise<{ success: boolean; id?: string; error?: string }> {
  try {
    const response = await fetch(`${API_URL}/api/leads`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    })

    const result = await response.json()
    
    if (!response.ok) {
      return { success: false, error: result.error || 'Submission failed' }
    }

    return { success: true, id: result.id }
  } catch (error) {
    console.error('API error:', error)
    return { success: false, error: 'Network error. Please try again.' }
  }
}

export async function uploadPhoto(
  file: File
): Promise<{ success: boolean; key?: string; error?: string }> {
  try {
    const formData = new FormData()
    formData.append('file', file)

    const response = await fetch(`${API_URL}/api/upload`, {
      method: 'POST',
      body: formData,
    })

    const result = await response.json()
    
    if (!response.ok) {
      return { success: false, error: result.error || 'Upload failed' }
    }

    return { success: true, key: result.key }
  } catch (error) {
    console.error('Upload error:', error)
    return { success: false, error: 'Upload failed. Please try again.' }
  }
}
